var _rect, _rect2, _rect3, _rect4, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 97,
    viewBox: "0 0 89 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 88.2109,
    y: 56.1338,
    width: 16.0382,
    height: 16.0382,
    transform: "rotate(-180 88.2109 56.1338)",
    fill: "#4EDFFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48.1133,
    y: 40.0957,
    width: 16.0382,
    height: 16.0382,
    fill: "#4EDFFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 40.0938,
    y: 56.1338,
    width: 16.0382,
    height: 16.0382,
    transform: "rotate(-180 40.0938 56.1338)",
    fill: "#4EDFFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 40.0957,
    width: 16.0382,
    height: 16.0382,
    fill: "#4EDFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0547 32.0762C24.055 14.3612 38.4158 3.36694e-05 56.1309 -2.80419e-06C73.8459 6.94427e-05 88.2067 14.3612 88.207 32.0762L72.1689 32.0762C72.1686 23.2189 64.9882 16.0382 56.1309 16.0381C47.4116 16.0381 40.3171 22.9967 40.0977 31.6631L40.0928 32.0762L24.0557 32.0762L24.0547 32.0762Z",
    fill: "#4EDFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1523 64.1523C64.1523 81.8676 49.7915 96.2285 32.0762 96.2285C14.361 96.2284 0 81.8676 0 64.1523H16.0381C16.0381 73.0099 23.2186 80.1913 32.0762 80.1914C40.7955 80.1914 47.8899 73.2328 48.1094 64.5664L48.1143 64.1523L64.1523 64.1523Z",
    fill: "#4EDFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/union.d9f3bc78b60df1f03ba3fe6837b1bc81.svg";
export { ForwardRef as ReactComponent };